/* eslint-disable no-unused-vars */
export const getCellDeletionButtonDecoratorStyle = ({ components, core: { palette = {} } = {} } = {}) => ({
  cellDeletionButtonDecorator: {
    position: 'absolute',
    bottom: 8,
    right: 10,
  },
  deleteButton: {
    backgroundColor: palette.themeLighter,
    opacity: 0.7,
    zIndex: 2,
    padding: 0,
    height: 24,
    width: 24,
    '&:hover': {
      opacity: 0.9,
    },
    '&:active': {
      opacity: 1,
    },
    '& .ms-Button-icon': {
      margin: 0,
    },
  },
});
